export default __webpack_public_path__ + "aad2ffb05d6f73b386cbf1d190da0465.jpg";